export const Divider = () => <div className="border-primary h-px border-b" />;
